import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject } from '@angular/core';
import {
    DealerFeature,
    LoginFeature,
    PageContentType,
    RouterLinkDirective,
    TrackingDirective,
    UiFeature,
    VehicleFavoritesService,
    VehicleFeature,
} from '@hyundai/ng-common-lib';
import { getEditDealerCampaignsUrl } from '@hyundai/shared-lib';
import { getRouterSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-nav-bar',
    standalone: true,
    imports: [RouterLinkDirective, NgClass, TrackingDirective],
    templateUrl: './nav-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class NavBarComponent {
    store = inject(Store);
    private readonly favoritesService = inject(VehicleFavoritesService);
    dealer = this.store.selectSignal(DealerFeature.state.selectSubDealerOrDealer);
    dealerServiceMailLink = this.store.selectSignal(DealerFeature.state.selectDealerServiceFormUrl);
    showMenu = this.store.selectSignal(UiFeature.state.selectShowMenu);
    login = this.store.selectSignal(LoginFeature.state.selectIsLoggedIn);
    vehicleDetail = this.store.selectSignal(VehicleFeature.vehicleState.selectDetail);
    routeContentType = this.store.selectSignal(getRouterSelectors().selectRouteDataParam('contentType'));
    favoritesCount = this.favoritesService.favoritesCount;

    editCampaignUrl = computed(() => {
        const dealer = this.dealer();
        if (!dealer) {
            return '';
        }
        return getEditDealerCampaignsUrl(dealer.parentDealerSlug ?? dealer.slug);
    });

    toggleMenu() {
        this.store.dispatch(this.showMenu() ? UiFeature.actions.hideMenu() : UiFeature.actions.showMenu());
    }

    logout() {
        this.store.dispatch(LoginFeature.actions.logout());
    }

    isVdp = computed(() => {
        return this.routeContentType() === PageContentType.VEHICLEDETAIL;
    });

    subDealerPhoneNumberOnVdp = computed(() => {
        if (!this.isVdp()) {
            return this.dealer().phone;
        }

        const vehicle = this.vehicleDetail();
        if (!vehicle) {
            return this.dealer().phone;
        }

        const subDealer = this.dealer().subDealers.find((d) => d.id === vehicle.dealer.id);

        return subDealer?.phone ?? this.dealer().phone;
    });
}
